export default "__VITE_ASSET__CYvYN0ew__"